
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parceria",
      function () {
        return require("private-next-pages/parceria.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parceria"])
      });
    }
  